var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
// import AwesomeSlider from 'react-awesome-slider';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withTranslation } from 'react-i18next';

var sliderProfiles = function (_Component) {
    _inherits(sliderProfiles, _Component);

    function sliderProfiles(props) {
        _classCallCheck(this, sliderProfiles);

        // this.myRefJ = this.props.myRefJ;
        var _this = _possibleConstructorReturn(this, (sliderProfiles.__proto__ || Object.getPrototypeOf(sliderProfiles)).call(this, props));

        _this.textInput = React.createRef();
        _this.state = {
            title: ''
        };
        return _this;
    }

    _createClass(sliderProfiles, [{
        key: 'getSnapshotBeforeUpdate',
        value: function getSnapshotBeforeUpdate(prevProps, prevState) {
            document.getElementById("inputEditProfile" + prevProps.profile.id).maxLength = "10";

            return { title: this.textInput.current.value };
        }

        // onClick(profile, props) {
        //     console.log(props);
        //     props.edit(profile.id);
        //     props.chargeProfile(profile.options, profile.center, profile.isTrafficLayerShown, profile.zoom);
        // }

    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState, snapshot) {
            this.textInput.current.focus();
            this.textInput.current.select();
            if (this.textInput.current.value === null) {}
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                profile = _props.profile,
                t = _props.t;


            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    null,
                    React.createElement('input', {
                        type: 'text',
                        className: 'input',
                        defaultValue: profile.title,
                        id: "inputEditProfile" + profile.id,
                        placeholder: t("map.sidebar.configurationMapProfiles.placeHolderInputProfile"),
                        ref: this.textInput,
                        style: { display: profile.edit ? 'inline-block' : 'none' }
                    })
                ),
                React.createElement(
                    FormGroup,
                    { 'aria-label': 'position', style: { padding: "0px" }, row: true },
                    React.createElement(FormControlLabel, {
                        value: 'start',
                        control: React.createElement(Switch, { checked: this.props.map.isTrafficLayerShown ? true : false, onClick: this.props.trafficLayerShow, inputProps: { 'aria-label': 'secondary checkbox' } }),
                        label: t("map.sidebar.configurationMapProfiles.liveTraffic"),
                        labelPlacement: 'start'
                    }),
                    React.createElement(FormControlLabel, {
                        value: 'start',
                        control: React.createElement(Switch, { checked: !this.props.map.options.disableDefaultUI ? true : false, onClick: this.props.toggleUi, inputProps: { 'aria-label': 'secondary checkbox' } }),
                        label: t("map.sidebar.configurationMapProfiles.controls"),
                        labelPlacement: 'start'
                    }),
                    React.createElement(FormControlLabel, {
                        value: 'start',
                        control: React.createElement(Switch, { checked: this.props.map.options.gestureHandling === "cooperative" ? true : false, onClick: this.props.mapMobile, inputProps: { 'aria-label': 'secondary checkbox' } }),
                        label: t("map.sidebar.configurationMapProfiles.mobileUsability"),
                        labelPlacement: 'start'
                    }),
                    React.createElement(FormControlLabel, {
                        value: 'start',
                        control: React.createElement(Switch, { checked: this.props.map.isVehicleGrouped ? true : false, onClick: this.props.changeGroupMarkerVehicle, inputProps: { 'aria-label': 'secondary checkbox' } }),
                        label: "Agrupar",
                        labelPlacement: 'start'
                    })
                ),
                React.createElement('div', { className: 'line-select' }),
                React.createElement(
                    'div',
                    { className: 'container-label-options' },
                    React.createElement(
                        'label',
                        { style: { display: profile.edit ? 'inline-block' : 'none' }, onClick: this.props.cancel.bind(this, profile.id) },
                        t("map.sidebar.configurationMapProfiles.buttonsCrud.cancel")
                    ),
                    React.createElement(
                        'label',
                        { style: { display: profile.edit ? 'inline-block' : 'none' }, onClick: this.props.save.bind(this, profile.id, this.textInput) },
                        t("map.sidebar.configurationMapProfiles.buttonsCrud.save")
                    ),
                    this.props.profile !== "" ? React.createElement(
                        'label',
                        { style: { display: profile.edit ? 'none' : 'inline-block' }, onClick: this.props.edit.bind(this, profile.id) },
                        t("map.sidebar.configurationMapProfiles.buttonsCrud.edit")
                    ) : null,
                    this.props.profile !== "" ? React.createElement(
                        'label',
                        { style: { display: profile.edit ? 'none' : 'inline-block' }, onClick: this.props.deleteProfile.bind(this, profile.id) },
                        t("map.sidebar.configurationMapProfiles.buttonsCrud.delete")
                    ) : null,
                    React.createElement(
                        'label',
                        { style: { display: profile.edit ? 'none' : 'inline-block' }, onClick: this.props.addProfile11 },
                        t("map.sidebar.configurationMapProfiles.buttonsCrud.addNew")
                    )
                )
            );
        }
    }]);

    return sliderProfiles;
}(Component);

export default withTranslation()(sliderProfiles);